"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBackButton = void 0;
function useBackButton(_) {
    // No-op
    // BackHandler is not available on web
}
exports.useBackButton = useBackButton;
//# sourceMappingURL=useBackButton.js.map